import useIframeZoom from '@hooks/useIframeZoom'
import { Box } from '@mui/joy'
import { theme } from '@ui/style'
import pxToRem from '@utils/pxToRem'

const BodyMixAd = () => {
	const { wrapperRef, iframeRef } = useIframeZoom()
	return (
		<Box
			marginBottom={pxToRem(40)}
			ref={wrapperRef}
			sx={{
				[theme.mediaQueries.under.origin]: {
					width: pxToRem(353),
					height: pxToRem(360),
				},
			}}
		>
			<iframe
				ref={iframeRef}
				src="//adv.imadrep.co.kr/9701_02.html"
				width="100%"
				height="360px"
				frameBorder="0"
				scrolling="no"
			/>
		</Box>
	)
}
export default BodyMixAd
